// extracted by extract-css-chunks-webpack-plugin
module.exports = {"outerContainer":"CookieBanner-2426c2dac3fbef46","innerContainer":"CookieBanner-a3aa74c15442fa14"};